export function extractTranslatableSeverityGridKeys(obj, key = null) {
  let keys = [];

  if (Array.isArray(obj) && typeof obj[0] === "object") {
    return [
      ...keys,
      ...obj.flatMap((item) => extractTranslatableSeverityGridKeys(item, key)),
    ];
  }

  if ("slug" in obj) {
    key = key === null ? obj.slug : `${key}.${obj.slug}`;
  }

  if ("components" in obj) {
    keys = [
      ...keys,
      ...obj.components.flatMap((item) =>
        extractTranslatableSeverityGridKeys(item, key)
      ),
    ];
  }

  if ("materials" in obj) {
    keys = [
      ...keys,
      ...obj.materials.flatMap((item) =>
        extractTranslatableSeverityGridKeys(item, key)
      ),
    ];
  }

  if ("defects" in obj) {
    keys = [...keys, ...obj.defects.flatMap((item) => `${key}.${item}`)];
  }

  return keys;
}
